import { getActiveSLAFromTicket } from './getActiveSLAFromTicket';
export const ticketHasActiveSLAs = ticket => Boolean(getActiveSLAFromTicket(ticket));